import { Parent } from "@/models/Parent"
import { Student, Students } from "@/models/Student"
import { Schedules } from "@/models/Schedule"
import { Lessons } from "@/models/Lesson"
import { Name } from "@/models/Name"
import firebase from 'firebase/app'
import { Address } from "@/models/Address"

class ParentRepository {
  constructor(client) {
    this.collection = client.collection("parents")
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async put(
    values
  ) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const parent = new Parent({
      uuid: values.uuid,
      name: new Name(
        values.personalName,
        values.familyName,
        values.flatPersonalName,
        values.flatFamilyName
      ),
      email: values.email,
      gender: values.gender,
      birthday: values.birthday,
      phone: values.phone,
      address: new Address(
        values.postalCode,
        values.prefecture,
        values.municipality,
        values.subAddress
      ),
      nearestStation: values.nearestStation,
      students: new Students([]),
      teacherIds: [],
      cardId: values.cardId,
      createdAt: timestamp,
      updatedAt: timestamp,
      active: true
    }
    )
    const object = parent.toObject()
    const docRef = await this.collection.doc(values.uuid)
    docRef.set(object.data)
    const result = await docRef.get()
    return createFromFireStoreData(values.uuid, result.data(this.snapShotOptions))
  }

  async get(id) {
    const result = await this.collection.doc(id).get()
    const data = result.data(this.snapShotOptions)
    if (data) {
      return createFromFireStoreData(id, data)
    }
  }

  async find(id) {
    return await this.get(id)
  }

  async update(parent) {
    parent.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
    const object = parent.toObject()
    const docRef = await this.collection.doc(parent.uuid)
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createFromFireStoreData(object.id, data)
  }

  async collect(uuids) {
    if (!(uuids instanceof Array)) {
      throw new TypeError(`'uuids' must be an instance of Array. Actual: ${typeof uuids}`)
    }
    const arr = await Promise.all(uuids.map(async uuid => {
      return await this.find(uuid)
    }))
    return arr
  }

}

const createFromFireStoreData = (id, data) => {
  return new Parent({
    uuid: id,
    name: new Name(
      data.personalName,
      data.familyName,
      data.flatPersonalName,
      data.flatFamilyName
    ),
    email: data.email,
    gender: data.gender,
    birthday: data.birthday.toDate(),
    phone: data.phone,
    address: new Address(
      data.postalCode,
      data.prefecture,
      data.municipality,
      data.subAddress
    ),
    nearestStation: data.nearestStation,
    students: new Students(
      data.students.map(student => {
        return new Student({
          id: student.id,
          parentId: student.data.parentId,
          name: new Name(
            student.data.personalName,
            student.data.familyName,
            student.data.flatPersonalName,
            student.data.flatFamilyName
          ),
          gender: student.data.gender,
          birthday: student.data.birthday.toDate(),
          availableSchedules: Schedules.createFromObjects(student.data.availableSchedules),
          address: new Address(
            student.data.postalCode,
            student.data.prefecture,
            student.data.municipality,
            student.data.subAddress
          ),
          nearestStation: student.data.nearestStation,
          teacherIds: student.data.teacherIds,
          lessons: Lessons.createFromObjects(student.data.lessons),
          createdAt: student.data.createdAt.toDate(),
          updatedAt: student.data.updatedAt.toDate()
        }
        )
      })
    ),
    teacherIds: data.teacherIds,
    cardId: data.cardId,
    createdAt: data.createdAt.toDate(),
    updatedAt: data.updatedAt.toDate(),
    active: data.active
  }
  )
}

export { ParentRepository }